// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1y9cj","inner":"Footer_inner__1kiIc"};